import * as React from 'react';

import {setBodyId} from '../../../dom';
import {PageContainer, PageTitleBar} from '../../../ui/layout';
import {InvoiceOverviewPage} from '../../../ui/setup/sales-documents/invoices/invoice-overview-page';

export function InvoiceOverviewPageStandalone() {
    setBodyId('invoice-overview');

    return (
        <PageContainer
            noPadding={true}
            title='Invoices'
            pageTitleBar={
                <PageTitleBar
                    title='Invoices'
                    subheaderPrimaryText='View, download, and restore invoices'
                />
            }
        >
            <InvoiceOverviewPage />
        </PageContainer>
    );
}
